import { render, staticRenderFns } from "./RelatorioExportacaoLogFornecedor.vue?vue&type=template&id=5cc4cf85"
import script from "./RelatorioExportacaoLogFornecedor.vue?vue&type=script&lang=js"
export * from "./RelatorioExportacaoLogFornecedor.vue?vue&type=script&lang=js"
import style0 from "./RelatorioExportacaoLogFornecedor.vue?vue&type=style&index=0&id=5cc4cf85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports